import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockTransferStatus implements BaseEnumType {
  private static allValues: EnumStockTransferStatus[] = []; // make sure this is top-most
  
  public static none = new EnumStockTransferStatus(0, "None", "enum_stock_transfer_status_none");
  public static open = new EnumStockTransferStatus(1, "Open", "enum_stock_transfer_status_open");
  public static cancelled = new EnumStockTransferStatus(2, "Cancelled", "enum_stock_transfer_status_cancelled");
  public static complete = new EnumStockTransferStatus(3, "Complete", "enum_stock_transfer_status_complete");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockTransferStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumStockTransferStatus.none; }
  public isOpen() { return this === EnumStockTransferStatus.open; }
  public isCancelled() { return this === EnumStockTransferStatus.cancelled; }
  public isComplete() { return this === EnumStockTransferStatus.complete; }

  public static getValues(): readonly EnumStockTransferStatus[] {
    return EnumStockTransferStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockTransferStatus[] {
    return EnumStockTransferStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockTransferStatus {
    const found = EnumStockTransferStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockTransferStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockTransferStatus): EnumStockTransferStatus {
    const found = name ? EnumStockTransferStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockTransferStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockTransferStatus>): boolean {
    return this.key === other?.key;
  }
}